export default "__VITE_ASSET__167P20tv__"